import { Component } from '@angular/core';

@Component({
    selector: 'app-datepicker-inline-calendar',
    templateUrl: './datepicker-inline-calendar.component.html',
    styleUrls: ['./datepicker-inline-calendar.component.scss']
})
export class DatepickerInlineCalendarComponent {}